export enum SortingOptionsEnum {
    PRICE_ASC = 0,
    PRICE_DESC = 1,
    TITLE_ASC = 2,
    TITLE_DESC = 3,
    DATE_ASC = 4,
    DATE_DESC = 5
}
